<template>
  <div>
    <div>
      <div class="row mt-3">
        <div class="col-12 pb-1 border-bottom">
          <h5 class="h5-sor">获得长期免费使用 <small class="text-muted">(邀请好友得时长)</small></h5>
        </div>

        <div class="col-11 ml-2 mt-3">
          <p>将下方链接或二维码分享给您的好友，好友通过您的链接注册并订购，您即可获得奖励</p>
        </div>
        <div id="qrcode" ref="qrcode" style="margin: 0 auto"></div>
      </div>

      <div class="row d-flex border mt-3 mb-3 px-3 py-3">
        <div class="col-7 align-self-center">
          <small class="">{{ shareLink }}</small>
        </div>
        <div class="col-5 align-self-center">
          <a @click="doCopy" class="copy btn btn-success btn-block ">复制地址</a>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-3 ml-2">账户余额: {{ userData.amount }}</div>
        <div class="col-4">订单金额: {{ userData.orderAmount }}</div>
        <div class="col-4">分享用户数: {{ count }}</div>
      </div>
      <div class="row">
        <h6 class="col-11 ml-2 mt-3">分享成功记录:</h6>

        <div class="col-12 mt-2">
          <!-- <table class="table table-bordered table-hover">
            <thead>
              <tr>
                <th>好友用户名</th>
                <th>奖励</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in users" :key="item.id">
                <td>{{ item.username }}</td>
                <td>{{ getLabelByValue(editionOptions, item.edition) }}&nbsp;{{ item.days }}天</td>
              </tr>
            </tbody>
          </table> -->
          <div class="col-12 pb-1">
            <el-table ref="multipleTable" :data="tableData">
              <el-table-column prop="username" label="用户名" width="150">
              </el-table-column>

              <el-table-column prop="email" label="邮箱">
              </el-table-column>

              <el-table-column prop="percent" label="分佣比例">
              </el-table-column>

              <el-table-column prop="orderAmount" label="订单金额">
              </el-table-column>

              <el-table-column prop="amount" label="佣金余额">
              </el-table-column>
              <el-table-column prop="edition" label="版本">
                <template slot-scope="scope">
                  <el-row>{{ comValue(editionOptions, scope.row.edition) }}</el-row>
                </template>
              </el-table-column>

              <el-table-column prop="status" label="状态" width="70">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.status === 1" type="success">可用</el-tag>
                  <el-tag v-if="scope.row.status === 0" type="danger">停用</el-tag>
                  <el-tag v-if="scope.row.status === 2">过期</el-tag>
                </template>
              </el-table-column>

              <el-table-column prop="limittime" label="过期日期" :formatter="tableDateFormat">
              </el-table-column>

              <el-table-column prop="updated_at" label="更新时间" :formatter="tableDateFormat">
              </el-table-column>

              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="handleDetail(scope.row)">详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination background layout="prev, pager, next" :pager-count="11" @current-change="pageChange"
            :current-page="page" :total="count">
          </el-pagination>
        </div>
        <div class="mx-auto">
        </div>
      </div>

      <div class="row mt-5 mb-5">
        <div class="col-12 pb-1 border-bottom">
          <h5 class="h5-sor">分享规则</h5>
        </div>

        <div class="col-11 mt-2">
          <p>1.邀请好友注册，好友通过邮箱验证领取体验时长后，将赠送您3天会员时长或2天 4K/VR体验，系统将自动发放奖励。</p>
          <p>2.好友完成订购（任意时长）后，赠送您7天会员时长或4天 4K/VR体验，系统自动发放奖励，多个好友邀请将会累计赠送。</p>
        </div>
      </div>
    </div>
    <footerPage></footerPage>
  </div>
</template>

<script>
import Qrcode from "qrcodejs2";
import qs from "qs"
import footerPage from '@/components/userInfo/footer'
import { removeToken, getUserId, getUser, getToken } from "../../axios/token";
export default {
  name: "shareLink",
  components: { footerPage },
  data () {
    return {
      users: [],
      user_id: parseInt(getUserId()),
      shareLink: this.common.footerLinkStr + '/login?promote_id=' + parseInt(getUserId()) + '&t=reg',
      editionOptions: [
        { label: '个人/企业版', value: 1 },
        { label: '4K视频不限速版', value: 2 },
        { label: 'Pro专业版', value: 3 }
      ],
      // shareLink:this.common.homeLink+parseInt(getUserId())+'&status=reg'
      page: 1,
      tableData: [],
      userData: {},
      count: 10
    }
  },
  computed: {
    comValue () {
      return (obj, status) => {
        return this.getLabelByValue(obj, status);
      }
    },
  },
  created () {
    // let data = {
    //   id: this.user_id
    // };
    // this.axios.post('/user/share', qs.stringify(data)).then(resp => {
    //   if (resp.data.code !== 0) {
    //     this.$message('错误，请稍后再查看')
    //   } else if (!resp.data.data || resp.data.data.length === 0) {
    //     this.$message('您还没有分享过好友')
    //   } else {
    //     this.users = resp.data.data
    //   }
    // })
    this.getProxyData(1)
    this.getUserData()
  },
  mounted () {
    this.makeQrcode(this.shareLink)
  },
  methods: {
    getLabelByValue (arr, value) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].value === value) {
          return arr[i].label;
        }
      }

      return null; // 如果未找到对应的label，则返回null或其他适合的默认值
    },
    makeQrcode (codeUrl) {
      new Qrcode(this.$refs.qrcode, {
        width: 200,
        height: 200,
        colorDark: '#333',//二维码颜色
        colorLight: '#fff',//二维码背景颜色
        text: codeUrl,
        correctLevel: Qrcode.CorrectLevel.L//容错率,L/M/H
      })
    },
    doCopy () {
      if (!this.user_id) {
        removeToken()
        this.$message('请重新登陆后再分享')
        this.$router.push('login')
        return;
      }
      let copyText = this.shareLink
      this.$copyText(copyText)
      this.$message({
        message: '复制成功',
        type: "success"
      })
    },
    pageChange (p) {
      this.getProxyData(p)
    },
    getUserData () {
      let data = {
        username: getUser()
      };
      this.axios.post('/user/detail', qs.stringify(data), {
        headers: {
          "Jwt": getToken()
        }
      }).then(res => {
        this.userData = res.data.data
      });
    },
    getProxyData (page, username, email) {
      this.page = page
      this.axios.get('/user/agentShare', {
        params: {
          shareId: this.user_id,
          page: page,
          username: username || '',
          email: email || ''
        }
      }).then(resp => {
        var data = resp.data.data
        this.tableData = data.datas;
        this.count = data.count
      }).catch(() => {
        this.$message.error('哦，请求出错');
      });
    },
    handleDetail (row) {
      this.$router.push(`/user/proxyDetail/${row.id}`)
    }
  }
}
</script>

<style scoped>
@media (min-width: 300px) and (max-width: 767px) {
  .h5-sor {
    font-size: 1.1rem;
  }

  .h5-sor small {
    font-size: 75%;
  }

  .account-info>dt {
    padding-right: 0;
  }

  .account-info>dd {
    padding-left: 0;
    padding-right: 0;
  }
}

body {
  position: relative;
  min-height: 100%;
  box-sizing: border-box;
  padding-bottom: 125px;
}

.account-info dt {
  line-height: 27px;
  height: 27px;
}

#download-groups a {
  min-height: 80px;
}
</style>